import { useSelector } from 'react-redux';
import { useMemo } from 'react';
import { checkFeatureAccess } from '../../../utils/helpers';
import globals from '../../../globals/communityGlobals';
import { ExternalProviderType } from '../../../enums';

const TreatmentImportStatusCheck = treatment => {
  const faList = useSelector(store => store.global.auth.featureAccessList);
  const externalProviderType = useSelector(store => store.global.auth.externalProviderType);

  const enableIntegrationMode = useMemo(
    () => checkFeatureAccess(faList, globals.applicationFeatureAccesses.enableIntegrationMode),
    [faList],
  );

  const isImportedFromSystmOne = useMemo(
    () => enableIntegrationMode && treatment.isImported && externalProviderType === ExternalProviderType.SystmOne,
    [enableIntegrationMode, treatment.isImported, externalProviderType],
  );

  return isImportedFromSystmOne;
};

export default TreatmentImportStatusCheck;
